/**
 * @file
 * Behaviors for the Filter Accordion.
 */

((Drupal, once) => {
  ('use strict');

  /**
   * Setup and attach the Accordion open/close behavior.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.accordion = {
    attach: (context) => {
      const handleClick = (accordion, toggle) => {
        // Identify the matching element.
        const content = accordion.querySelector(
          '#' + toggle.getAttribute('aria-controls')
        );

        if (!accordion.classList.contains('open')) {
          // Accordion does not have `.open`, so we are opening the accordion.
          accordion.classList.add('open');
          // Toggle the `aria-expanded`.
          toggle.setAttribute('aria-expanded', 'true');
          // Toggle the `aria-hidden` attribute on the content.
          content.setAttribute('aria-hidden', 'false');
        }
        else {
          // Same as the if, but in reverse.
          accordion.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
          content.setAttribute('aria-hidden', 'true');
        }
      };

      once('accordion', '.accordion', context).forEach((accordion) => {
        // Attach click handler for accordion.
        let toggle = accordion.querySelector('.accordion__toggle');
        toggle.addEventListener('click', () => {
          handleClick(accordion, toggle);
        });
      });
    }
  };
  // eslint-disable-next-line no-undef
})(Drupal, once);
